import React from "react";
import style from "./about.module.scss";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { gsap } from "gsap/dist/gsap";

const AboutUsUI = () => {
  const navigate = useNavigate();
  return (
    <>
      <motion.div
        className={style.container}
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -20, opacity: 0 }}
        transition={{ duration: 0.7 }}
      >
        <h1>ABOUT US</h1>
        <p>
          Texhnext is a Technological Solutions Development drive aimed at using
          superior IT and engineering prowess to create simple solutions that .
          Our current clientele is a rich variety of government, public and
          privately owned businesses who have become acquainted with our unusual
          drive for excellent service delivery. We're a team of engineers,
          scientists, and mathematicians who are passionate about solving some
          of the world's most complex problems. We're here to make sure that
          your business has all the tools it needs to succeed—you just tell us
          what you need. We believe in providing excellent service that goes
          above and beyond expectations. We are confident in our ability to
          deliver on this promise because we've been doing it for years—and we
          hope you'll join us on this journey!
        </p>
        <p>
          We're always open to new ideas, big or small. From start-ups to
          enterprises, we'll be happy to share our expert advice with you on how
          we can solve your problem or how we could help you on your journey.
          Hire us!
        </p>
        <p>
          We work with clients from all over the world, from start-ups to
          multinationals. Our skilled team of IT engineers and industrial
          designers will bring your product idea from prototype to finished
          product.
        </p>

        <button
          onClick={() => {
            navigate("/contact");
          }}
        >
          CONTACT US
        </button>
      </motion.div>
    </>
  );
};

export { AboutUsUI };
